import { deepResolvePackageAssetUrls } from '../assetUrls.js';

const rawConfig = {
  "navbarConfig": {
    "logo": "/assets/defaultLogo.png",
    "logoText": "Padami",
    "links": [
      {
        "label": "HOME",
        "href": "/"
      },
      {
        "label": "PRODUCTS",
        "href": "/products"
      },
      {
        "label": "SERVICES",
        "href": "/services"
      },
      {
        "label": "CONTACT",
        "href": "/contact-us"
      },
      {
        "label": "ABOUT",
        "href": "/about-us"
      },
      {
        "label": "REVIEW",
        "href": "/#reviews"
      }
    ],
    "searchPlaceholder": "Search your products",
    "searchIcon": "🔍",
    "cameraIcon": "📷",
    "cameraLabel": "Camera",
    "loginIcon": "👤",
    "loginLabel": "Login",
    "backgroundColor": "#F7F7F7",
    "textColor": "#6b2b52",
    "logoTextColor": "#7B506F",
    "searchBackgroundColor": "#ffffff",
    "searchBorderColor": "#e8d4dc",
    "searchTextColor": "#7a7a7a",
    "iconColor": "#6b2b52",
    "hoverColor": "#8b3a6a",
    "borderBottom": "#e8d4dc"
  }
}
;

const resolvedConfig = deepResolvePackageAssetUrls(rawConfig);

export default resolvedConfig;

